/* ==========================================================
   LE BILAN NUIT — script extrait de sections/app-bilan-email.liquid.
   Il etait inline (~32 Ko dans le HTML de chaque page d'accueil). Charge en
   defer, il ne retarde plus l'analyse du document ni la peinture du heros.

   Le corps d'origine est place dans bnBoot() : inline, il se rejouait a chaque
   rechargement de la section dans l'editeur de theme. Un fichier externe n'est
   evalue qu'une fois, d'ou le rappel explicite sur shopify:section:load pour
   conserver ce comportement.
   ========================================================== */
(function () {
  function bnBoot() {

(function(){
"use strict";

var APP  = document.getElementById('bn-app');
var VIEW = document.getElementById('bn-view');
var FILL = document.getElementById('bn-fill');
var STEP = document.getElementById('bn-step');
var BACK = document.getElementById('bn-back');
var TOAST= document.getElementById('bn-toast');

var CTA_URL   = APP.getAttribute('data-cta-url')   || '#';
var CTA_LABEL = APP.getAttribute('data-cta-label') || 'Voir le produit';

/* ---------------------------------------------------------
   Persistance : sessionStorage, avec repli mémoire.
   Rien n'est envoyé nulle part. Aucune requête réseau.
   --------------------------------------------------------- */
var KEY = 'alcove.bilan-nuit.v1';
var mem = null;
var store = {
  read: function(){
    try{ var r = sessionStorage.getItem(KEY); return r ? JSON.parse(r) : null; }
    catch(e){ return mem; }
  },
  write: function(o){
    mem = o;
    try{ sessionStorage.setItem(KEY, JSON.stringify(o)); }catch(e){}
  },
  clear: function(){
    mem = null;
    try{ sessionStorage.removeItem(KEY); }catch(e){}
  }
};

function blank(){
  return { age:null, sexe:null, taille:null, poids:null, cou:null, couNsp:false,
           ronfle:null, fatigue:null, arrets:null, hta:null,
           contre:[], leviers:[], done:false };
}
var S = store.read() || blank();
var i = S.done ? 8 : 0;

/* ---------------------------------------------------------
   Contenu
   --------------------------------------------------------- */
var CONTRE = [
  { id:'centrales', bloc:true,  t:"Des apnées centrales m'ont été diagnostiquées",
    h:"Le cerveau n'envoie plus l'ordre de respirer : mécanisme différent de l'obstruction." },
  { id:'dentier',   bloc:true,  t:"Je porte un dentier complet, ou il me reste très peu de dents naturelles",
    h:"L'orthèse a besoin de dents solides sur lesquelles s'appuyer." },
  { id:'chirurgie', bloc:true,  t:"J'ai eu une chirurgie ORL ou de la mâchoire il y a moins d'un an" },
  { id:'neuro',     bloc:true,  t:"J'ai un trouble neurologique ou neuromusculaire" },
  { id:'mineur',    bloc:true,  t:"J'ai moins de 18 ans",
    h:"La mâchoire est encore en croissance." },
  { id:'atm',       bloc:false, t:"J'ai des douleurs, des craquements ou des blocages de la mâchoire",
    h:"Articulation temporo-mandibulaire (ATM)." },
  { id:'paro',      bloc:false, t:"J'ai un déchaussement, des dents mobiles ou une parodontite non traitée" },
  { id:'rien',      bloc:false, t:"Rien de tout cela", excl:true }
];

var LEVIERS = [
  { id:'dos',   t:"Je dors surtout sur le dos" },
  { id:'alcool',t:"Je bois de l'alcool le soir, au moins 3 soirs par semaine" },
  { id:'nez',   t:"J'ai souvent le nez bouché la nuit" },
  { id:'somni', t:"Je prends des somnifères ou des décontractants musculaires" },
  { id:'poids', t:"J'ai pris du poids ces dernières années" },
  { id:'rienL', t:"Rien de tout cela", excl:true }
];

var CONSEILS = {
  dos: { h:"Quittez le dos, cette nuit",
    p:"Sur le dos, la langue et le voile du palais retombent vers l'arrière-gorge : c'est la position qui aggrave le plus l'obstruction. La vieille astuce fonctionne encore : une balle de tennis cousue dans une poche au dos du t-shirt de nuit, ou un traversin calé le long du dos. Effet dès la première nuit, coût nul." },
  alcool:{ h:"Décalez le dernier verre de 3 heures",
    p:"L'alcool relâche les muscles du pharynx pendant les premières heures de sommeil : il transforme un ronflement léger en ronflement franc, et augmente le nombre d'apnées. Ce n'est pas « arrêter de boire » : c'est terminer 3 à 4 heures avant de vous coucher." },
  nez: { h:"Rouvrez le nez avant de tenter quoi que ce soit",
    p:"Un nez bouché force la respiration buccale, qui entretient le ronflement : et rend une orthèse difficile à supporter. Lavage au sérum physiologique le soir, chambre pas trop sèche, et un avis ORL si l'obstruction est permanente (déviation de cloison, allergie). C'est le prérequis, pas l'accessoire." },
  somni:{ h:"Parlez de vos somnifères à votre médecin",
    p:"Benzodiazépines et myorelaxants agissent sur le tonus musculaire comme l'alcool : ils peuvent aggraver les apnées. À évoquer lors de votre prochaine consultation : n'arrêtez jamais un traitement de votre propre initiative." },
  poids:{ h:"Visez 10 %, pas la perfection",
    p:"La graisse péri-pharyngée réduit le calibre des voies aériennes. Les travaux sur le sujet montrent qu'une perte de poids modérée, de l'ordre de 10 %, réduit nettement l'index d'apnées. Ce n'est pas une injonction esthétique : c'est le seul levier qui agit sur la cause." },
  tete:{ h:"Surélevez la tête du lit, pas l'oreiller",
    p:"Environ 10 à 15 cm de cales sous les pieds de tête du lit. Empiler les oreillers plie le cou et referme la gorge : l'effet est inverse de celui recherché." },
  rythme:{ h:"Couchez-vous à heure fixe, même le week-end",
    p:"La dette de sommeil approfondit le relâchement musculaire lors de l'endormissement suivant. Un rythme régulier réduit l'intensité du ronflement des nuits de rattrapage." },
  repas:{ h:"Dîner léger, et deux heures d'écart",
    p:"Un repas lourd tardif favorise le reflux et la congestion des muqueuses de la gorge. Deux heures entre la fin du dîner et le coucher suffisent à faire une différence audible." }
};

/* ---------------------------------------------------------
   Écrans
   --------------------------------------------------------- */
/* assemblé en bas de fichier, une fois les écrans binaires construits */
var SCREENS = [];
var TOTAL = 7; /* on ne compte ni l'intro ni le résultat */

function render(){
  BACK.hidden = (i === 0 || i === SCREENS.length - 1);
  if(i === 0 || i === SCREENS.length - 1){
    FILL.style.width = (i === 0 ? '0%' : '100%');
    STEP.textContent = '';
  } else {
    FILL.style.width = ((i / TOTAL) * 100) + '%';
    STEP.textContent = i + ' / ' + TOTAL;
  }
  VIEW.innerHTML = '';
  VIEW.appendChild(SCREENS[i]());
  if(i > 0) VIEW.scrollIntoView({block:'start', behavior:'smooth'});
}

function el(html){ var d = document.createElement('div'); d.className='bn-screen'; d.innerHTML = html; return d; }
function next(){ i++; save(); render(); }
function save(){ store.write(S); }
function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

BACK.addEventListener('click', function(){ if(i>0){ i--; render(); } });

/* --- 0. intro --- */
function scrIntro(){
  var d = el(
    '<h2>Le Bilan <em>Nuit</em></h2>' +
    '<p class="bn-lede">Sept questions, moins de deux minutes. À la fin vous saurez deux choses : où se situe votre risque d\'apnée du sommeil, et si une orthèse est faite pour vous : <strong>y compris quand la réponse est non</strong>.</p>' +
    '<button class="bn-cta" id="bn-go" type="button">Commencer le bilan</button>' +
    '<p class="bn-note"><b>Vos réponses restent privées pendant le bilan.</b> Elles restent dans cet onglet jusqu\'à la validation de votre inscription.</p>' +
    ''
  );
  d.querySelector('#bn-go').addEventListener('click', function(){
    if(S.done){ S = blank(); store.clear(); }
    next();
  });
  return d;
}

/* --- 1. profil --- */
function scrProfil(){
  var d = el(
    '<div class="bn-eyebrow">Étape 1 : Votre profil</div>' +
    '<h3 class="bn-q">Quelques repères sur vous</h3>' +
    '<p class="bn-sub bn-tight">L\'âge, le sexe, la corpulence et le tour de cou pèsent dans le dépistage de l\'apnée : ce ne sont pas des questions de politesse.</p>' +
    '<div class="bn-grid">' +
      '<div class="bn-field bn-full"><label>Vous êtes</label>' +
        '<div class="bn-seg" id="bn-sexe">' +
          '<button type="button" data-v="h" aria-pressed="false">Un homme</button>' +
          '<button type="button" data-v="f" aria-pressed="false">Une femme</button>' +
        '</div></div>' +
      '<div class="bn-field"><label for="bn-age">Âge</label><input type="number" id="bn-age" inputmode="numeric" min="10" max="110" placeholder="52"></div>' +
      '<div class="bn-field"><label for="bn-cou">Tour de cou (cm)</label><input type="number" id="bn-cou" inputmode="numeric" min="25" max="70" placeholder="41"></div>' +
      '<div class="bn-field"><label for="bn-taille">Taille (cm)</label><input type="number" id="bn-taille" inputmode="numeric" min="120" max="230" placeholder="178"></div>' +
      '<div class="bn-field"><label for="bn-poids">Poids (kg)</label><input type="number" id="bn-poids" inputmode="numeric" min="30" max="300" placeholder="88"></div>' +
    '</div>' +
    '<div class="bn-opts"><button class="bn-opt" type="button" id="bn-nsp" data-multi aria-pressed="false">' +
      '<span class="bn-mark"></span><span class="bn-lbl">Je ne connais pas mon tour de cou' +
      '<span class="bn-hint">Un mètre de couturière au niveau de la pomme d\'Adam. Sans mesure, le score peut être sous-estimé.</span></span></button></div>' +
    '<button class="bn-cta" id="bn-next" type="button" disabled>Continuer</button>' +
    '<p class="bn-note">Taille et poids servent à calculer votre IMC, l\'un des huit critères. Vous pouvez les laisser vides.</p>'
  );

  var btn = d.querySelector('#bn-next');
  var age = d.querySelector('#bn-age');
  var cou = d.querySelector('#bn-cou');
  var nsp = d.querySelector('#bn-nsp');

  d.querySelector('#bn-taille').value = S.taille || '';
  d.querySelector('#bn-poids').value  = S.poids  || '';
  age.value = S.age || '';
  cou.value = S.cou || '';
  nsp.setAttribute('aria-pressed', S.couNsp ? 'true' : 'false');
  if(S.couNsp) cou.disabled = true;

  d.querySelectorAll('#bn-sexe button').forEach(function(b){
    if(S.sexe === b.getAttribute('data-v')) b.setAttribute('aria-pressed','true');
    b.addEventListener('click', function(){
      d.querySelectorAll('#bn-sexe button').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      S.sexe = b.getAttribute('data-v');
      check();
    });
  });

  nsp.addEventListener('click', function(){
    S.couNsp = nsp.getAttribute('aria-pressed') !== 'true';
    nsp.setAttribute('aria-pressed', S.couNsp ? 'true' : 'false');
    cou.disabled = S.couNsp;
    if(S.couNsp){ cou.value = ''; S.cou = null; }
    check();
  });

  d.querySelectorAll('input').forEach(function(inp){
    inp.addEventListener('input', function(){
      var v = inp.value === '' ? null : parseFloat(inp.value);
      if(inp.id === 'bn-age')    S.age    = v;
      if(inp.id === 'bn-cou')    S.cou    = v;
      if(inp.id === 'bn-taille') S.taille = v;
      if(inp.id === 'bn-poids')  S.poids  = v;
      check();
    });
  });

  function check(){
    btn.disabled = !(S.sexe && S.age > 0 && (S.couNsp || S.cou > 0));
  }
  check();
  btn.addEventListener('click', next);
  return d;
}

/* --- questions binaires --- */
function binaire(key, eyebrow, question, sub, ouiHint, nonHint){
  return function(){
    var d = el(
      '<div class="bn-eyebrow">' + eyebrow + '</div>' +
      '<h2 class="bn-q">' + question + '</h2>' +
      '<p class="bn-sub">' + sub + '</p>' +
      '<div class="bn-opts">' +
        '<button class="bn-opt" type="button" data-v="1" aria-pressed="' + (S[key]===1?'true':'false') + '"><span class="bn-mark"></span><span class="bn-lbl">Oui' + (ouiHint ? '<span class="bn-hint">' + ouiHint + '</span>' : '') + '</span></button>' +
        '<button class="bn-opt" type="button" data-v="0" aria-pressed="' + (S[key]===0?'true':'false') + '"><span class="bn-mark"></span><span class="bn-lbl">Non' + (nonHint ? '<span class="bn-hint">' + nonHint + '</span>' : '') + '</span></button>' +
      '</div>'
    );
    d.querySelectorAll('.bn-opt').forEach(function(b){
      b.addEventListener('click', function(){
        d.querySelectorAll('.bn-opt').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        S[key] = parseInt(b.getAttribute('data-v'), 10);
        setTimeout(next, 190);
      });
    });
    return d;
  };
}

var scrRonfle = binaire('ronfle', 'Étape 2 : Le bruit',
  'Ronflez-vous fort ?',
  "Assez fort pour être entendu à travers une porte fermée, ou pour déranger la personne qui dort à côté de vous. Si vous l'ignorez, fiez-vous à ce qu'on vous en dit.",
  "On me l'a déjà reproché, ou je dors seul(e) à cause de ça.",
  "Léger, ou personne ne s'en est jamais plaint.");

var scrFatigue = binaire('fatigue', 'Étape 3 : Le lendemain',
  'Vous sentez-vous fatigué dans la journée ?',
  "Somnolence, coup de barre en réunion, envie de dormir devant la télé ou au volant : alors que vous avez passé une nuit de durée normale.",
  "Souvent, malgré des nuits qui semblent suffisantes.",
  "Je me réveille reposé la plupart du temps.");

var scrArrets = binaire('arrets', 'Étape 4 : Le signal fort',
  "A-t-on déjà remarqué que vous arrêtiez de respirer ?",
  "Pauses respiratoires pendant le sommeil, suivies d'une reprise bruyante ou d'un sursaut. C'est presque toujours le partenaire qui le constate : rarement le dormeur.",
  "On me l'a rapporté au moins une fois.",
  "Jamais, ou personne n'a pu l'observer.");

var scrHta = binaire('hta', 'Étape 5 : Santé',
  'Avez-vous de la tension, ou un traitement pour la tension ?',
  "L'hypertension artérielle et l'apnée du sommeil s'entretiennent l'une l'autre. Sa présence pèse dans le dépistage.",
  "Oui, diagnostiquée ou traitée.",
  "Non, à ma connaissance.");

/* --- 6. contre-indications --- */
function scrContre(){
  var opts = CONTRE.map(function(c){
    return '<button class="bn-opt" type="button" data-multi data-id="' + c.id + '" aria-pressed="' + (S.contre.indexOf(c.id)>-1?'true':'false') + '">' +
      '<span class="bn-mark"></span><span class="bn-lbl">' + c.t + (c.h ? '<span class="bn-hint">' + c.h + '</span>' : '') + '</span></button>';
  }).join('');
  var d = el(
    '<div class="bn-eyebrow">Étape 6 : Compatibilité</div>' +
    '<h2 class="bn-q">Est-ce que l\'une de ces situations vous concerne ?</h2>' +
    '<p class="bn-sub">Ce sont les cas où une orthèse d\'avancée mandibulaire est déconseillée, ou doit être validée par un professionnel. Cochez tout ce qui s\'applique : plusieurs réponses possibles.</p>' +
    '<div class="bn-opts">' + opts + '</div>' +
    '<button class="bn-cta" id="bn-next" type="button" ' + (S.contre.length?'':'disabled') + '>Continuer</button>'
  );
  wireMulti(d, 'contre', CONTRE, 'rien');
  return d;
}

/* --- 7. leviers --- */
function scrLeviers(){
  var opts = LEVIERS.map(function(c){
    return '<button class="bn-opt" type="button" data-multi data-id="' + c.id + '" aria-pressed="' + (S.leviers.indexOf(c.id)>-1?'true':'false') + '">' +
      '<span class="bn-mark"></span><span class="bn-lbl">' + c.t + '</span></button>';
  }).join('');
  var d = el(
    '<div class="bn-eyebrow">Étape 7 : Vos habitudes</div>' +
    '<h2 class="bn-q">Dernière question, celle qui sert ce soir</h2>' +
    '<p class="bn-sub">Elle détermine les trois leviers que nous allons vous donner : ceux qui agissent dès cette nuit, sans rien acheter.</p>' +
    '<div class="bn-opts">' + opts + '</div>' +
    '<button class="bn-cta" id="bn-next" type="button" ' + (S.leviers.length?'':'disabled') + '>Voir mon bilan</button>'
  );
  wireMulti(d, 'leviers', LEVIERS, 'rienL');
  return d;
}

function wireMulti(d, key, list, exclId){
  var btn = d.querySelector('#bn-next');
  d.querySelectorAll('.bn-opt').forEach(function(b){
    b.addEventListener('click', function(){
      var id = b.getAttribute('data-id');
      var on = b.getAttribute('aria-pressed') !== 'true';
      if(id === exclId){
        S[key] = on ? [exclId] : [];
      } else {
        S[key] = S[key].filter(function(x){ return x !== exclId && x !== id; });
        if(on) S[key].push(id);
      }
      d.querySelectorAll('.bn-opt').forEach(function(x){
        x.setAttribute('aria-pressed', S[key].indexOf(x.getAttribute('data-id')) > -1 ? 'true' : 'false');
      });
      btn.disabled = S[key].length === 0;
    });
  });
  btn.addEventListener('click', next);
}

/* ---------------------------------------------------------
   Calcul : STOP-BANG (8 items, 1 point chacun)
   0–2 risque faible · 3–4 intermédiaire · 5–8 élevé
   --------------------------------------------------------- */
function compute(){
  var imc = null;
  if(S.taille > 0 && S.poids > 0){ imc = S.poids / Math.pow(S.taille / 100, 2); }

  var items = {
    S: S.ronfle === 1,
    T: S.fatigue === 1,
    O: S.arrets === 1,
    P: S.hta === 1,
    B: imc !== null && imc > 35,
    A: S.age > 50,
    N: !S.couNsp && S.cou > 40,
    G: S.sexe === 'h'
  };
  var score = 0;
  for(var k in items){ if(items[k]) score++; }

  var band = score <= 2 ? 'faible' : (score <= 4 ? 'intermediaire' : 'eleve');
  /* règle affinée : 3–4 avec un critère lourd = à traiter comme un risque supérieur */
  var affine = band === 'intermediaire' && (items.O || items.B || items.N);

  var blocs = CONTRE.filter(function(c){ return c.bloc && S.contre.indexOf(c.id) > -1; });
  var relat = CONTRE.filter(function(c){ return !c.bloc && !c.excl && S.contre.indexOf(c.id) > -1; });

  return { score:score, band:band, affine:affine, imc:imc, items:items, blocs:blocs, relat:relat };
}

function buildLeviers(r){
  var out = [];
  var L = S.leviers;
  if(L.indexOf('dos') > -1)    out.push(CONSEILS.dos);
  if(L.indexOf('nez') > -1)    out.push(CONSEILS.nez);
  if(L.indexOf('alcool') > -1) out.push(CONSEILS.alcool);
  if(L.indexOf('poids') > -1 || (r.imc !== null && r.imc >= 27)) out.push(CONSEILS.poids);
  if(L.indexOf('somni') > -1)  out.push(CONSEILS.somni);
  var filler = [CONSEILS.tete, CONSEILS.rythme, CONSEILS.repas];
  var f = 0;
  while(out.length < 3 && f < filler.length){ out.push(filler[f++]); }
  return out.slice(0, 3);
}

/* ---------------------------------------------------------
   8. résultat
   --------------------------------------------------------- */
function scrResult(){
  S.done = true; save();
  var r = compute();
  var lev = buildLeviers(r);

  /* --- verdict compatibilité --- */
  var vTag, vTitle, vBody, caution = false, sell = true, soft = false;

  if(r.blocs.length){
    caution = true; sell = false;
    vTag = 'Notre réponse : non';
    vTitle = "L'orthèse n'est pas la solution pour vous";
    vBody = '<p>Nous préférons vous le dire tout de suite plutôt que de vous vendre quelque chose qui ne marchera pas. Ce que vous avez coché est une contre-indication reconnue :</p><ul style="margin:0 0 13px;padding-left:18px;">';
    r.blocs.forEach(function(c){
      var why = {
        centrales:"une orthèse avance la mâchoire pour libérer le passage de l'air. Elle ne peut rien contre une commande respiratoire défaillante : c'est l'objection la plus juste qui soit faite à ce dispositif.",
        dentier:"sans dents d'appui suffisantes, l'orthèse n'a rien pour tenir et le risque de dégât dentaire devient réel.",
        chirurgie:"les tissus doivent avoir fini de cicatriser avant toute contrainte mécanique nocturne.",
        neuro:"le tonus musculaire et la commande respiratoire relèvent d'une prise en charge spécialisée.",
        mineur:"une avancée mandibulaire prolongée peut modifier une croissance en cours."
      }[c.id] || '';
      vBody += '<li style="margin-bottom:7px;"><strong>' + c.t + '</strong> : ' + why + '</li>';
    });
    vBody += '</ul><p>Ce qui reste utile pour vous : les trois leviers ci-dessous, qui ne dépendent d\'aucun appareil, et un avis médical si vous ne l\'avez pas encore pris.</p>';
  }
  else if(r.band === 'eleve'){
    caution = true; sell = false; soft = true;
    vTag = 'Notre réponse : pas avant un dépistage';
    vTitle = "Faites-vous dépister avant d'acheter quoi que ce soit";
    vBody = '<p>Votre score situe votre risque d\'apnée obstructive dans la zone haute. À ce niveau, la première dépense utile n\'est pas un dispositif : <strong>c\'est un enregistrement du sommeil</strong>, prescrit par votre médecin traitant, un pneumologue ou un ORL. Il est en général pris en charge.</p>' +
      '<p>Deux raisons de ne pas sauter cette étape. D\'abord, sur les apnées sévères, la référence reste la ventilation par pression positive : une orthèse seule risque de vous faire perdre des mois. Ensuite, seul l\'examen distingue une apnée obstructive d\'une apnée centrale, sur laquelle aucune orthèse n\'agit.</p>' +
      '<p>Si l\'examen conclut à une apnée légère à modérée, ou à une intolérance à la PPC, revenez nous voir : c\'est exactement notre terrain.</p>';
  }
  else if(r.relat.length){
    vTag = 'Notre réponse : oui, après un feu vert';
    vTitle = "Faites valider par votre dentiste, puis lancez-vous";
    var quoi = r.relat.map(function(c){ return c.id === 'atm' ? "vos douleurs de mâchoire" : "l'état de vos gencives"; }).join(' et ');
    vBody = '<p>Sur le fond, votre profil correspond bien à ce que traite une orthèse d\'avancée mandibulaire. Mais vous avez signalé ' + quoi + ' : et c\'est précisément le terrain où un dispositif mal supporté fait des dégâts durables.</p>' +
      '<p>Un contrôle chez votre dentiste, avec la question posée telle quelle : <strong>« mon état dentaire permet-il de porter une orthèse d\'avancée mandibulaire la nuit ? »</strong> : suffit à trancher. C\'est une consultation, pas un parcours.</p>' +
      (r.band === 'intermediaire'
        ? '<p>Votre score évoque par ailleurs une apnée légère à modérée possible : profitez de ce rendez-vous pour demander aussi un dépistage du sommeil.</p>'
        : '<p>Votre score de risque reste bas : vous êtes probablement dans le ronflement simple, la situation la plus favorable.</p>');
  }
  else if(r.band === 'intermediaire'){
    vTag = 'Notre réponse : oui, et faites-vous dépister';
    vTitle = "Vous êtes sur le terrain où l'orthèse est la plus efficace";
    vBody = '<p>Votre score évoque une <strong>apnée obstructive légère à modérée possible</strong>. C\'est précisément le profil sur lequel l\'orthèse d\'avancée mandibulaire donne ses meilleurs résultats : et ceux pour lesquels elle est le plus souvent proposée comme alternative à la PPC.</p>' +
      '<p>Une orthèse n\'est pas un examen, et rien ici ne vous dit avec certitude que vous faites des apnées. En parallèle de l\'essai, demandez un enregistrement du sommeil à votre médecin : vous saurez d\'où vous partez, et vous pourrez mesurer ce que ça change.</p>' +
      (r.affine ? '<p>Un point d\'attention : vous cumulez un critère lourd (pauses respiratoires observées, corpulence ou tour de cou élevés) avec un score intermédiaire. Ne repoussez pas le dépistage à plus tard.</p>' : '');
  }
  else if(S.ronfle === 1){
    vTag = 'Notre réponse : oui, sans réserve';
    vTitle = "Ronflement simple probable: le meilleur cas de figure";
    vBody = '<p>Vous ronflez, mais les signaux d\'apnée sont peu présents : votre score de risque est bas. C\'est la situation la plus simple, et celle où une orthèse d\'avancée mandibulaire agit le plus directement : elle libère mécaniquement le passage de l\'air à l\'arrière de la gorge, là où naît le bruit.</p>' +
      '<p>Pas de contre-indication signalée, pas de parcours médical nécessaire. Commencez par les trois leviers ci-dessous ; ils sont gratuits et parfois suffisants. Si le bruit persiste, l\'orthèse est l\'étape logique.</p>';
  }
  else {
    vTag = 'Notre réponse : rien à traiter pour l\'instant';
    vTitle = "Rien n'indique un problème de votre côté";
    vBody = '<p>Ni ronflement franc, ni signaux d\'apnée, score de risque bas : sur la base de ces réponses, vous n\'avez pas besoin d\'une orthèse. Nous préférons vous le dire.</p>' +
      '<p>Si vous avez fait ce bilan pour quelqu\'un d\'autre : ce qui est fréquent : refaites-le en répondant pour cette personne : les résultats n\'ont rien à voir d\'un profil à l\'autre.</p>';
    sell = false;
  }

  /* --- jauge --- */
  var bars = '';
  for(var b = 1; b <= 8; b++){
    var on = b <= r.score;
    bars += '<i style="--i:' + b + '" class="' + (on ? 'on' + (r.band === 'eleve' ? ' bn-hot' : '') : '') + '"></i>';
  }
  var bandLbl = { faible:'Risque faible', intermediaire:'Risque intermédiaire', eleve:'Risque élevé' }[r.band];

  /* --- leviers --- */
  var levHtml = lev.map(function(c, n){
    return '<div class="bn-lever"><div class="bn-n">' + (n+1) + '</div><div><h4>' + c.h + '</h4><p>' + c.p + '</p></div></div>';
  }).join('');

  var d = el(
    '<div class="bn-eyebrow">Votre bilan</div>' +
    '<div class="bn-email-gate" id="bn-email-gate">' +
      '<h3>Votre bilan est prêt.</h3>' +
      '<p>Entrez votre adresse email pour découvrir votre résultat complet et recevoir nos conseils pour mieux dormir.</p>' +
      '<div id="bn-email-form-slot"></div>' +
      '<p class="bn-email-error" id="bn-email-error" role="alert">Veuillez entrer une adresse email valide.</p>' +
      '<p class="bn-email-consent">En vous inscrivant, vous acceptez de recevoir nos emails. Désinscription possible à tout moment.</p>' +
    '</div>' +
    '<div id="bn-result-content" hidden>' +
    '<h2 style="font-size:clamp(30px,6vw,42px);">Ce que disent <em>vos réponses</em></h2>' +

    '<div class="bn-gauge">' +
      '<div class="bn-gauge-head"><span class="bn-gauge-lbl">Score de dépistage STOP-BANG</span>' +
      '<span class="bn-gauge-val">' + r.score + ' / 8</span></div>' +
      '<div class="bn-gauge-track">' + bars + '</div>' +
      '<div class="bn-gauge-scale"><span>0–2 faible</span><span>3–4 intermédiaire</span><span>5–8 élevé</span></div>' +
      '<p class="bn-note" style="margin-top:13px;"><b>' + bandLbl + '.</b> ' +
        (r.imc !== null ? 'IMC calculé : ' + r.imc.toFixed(1) + '. ' : 'IMC non calculé (taille ou poids non renseignés). ') +
        (S.couNsp ? 'Tour de cou non mesuré : votre score réel est peut-être supérieur d\'un point.' : '') +
      '</p>' +
    '</div>' +

    '<div class="bn-verdict' + (caution ? ' bn-caution' : '') + '">' +
      '<div class="bn-vtag">' + vTag + '</div>' +
      '<h2 class="bn-vtitle">' + vTitle + '</h2>' + vBody +
    '</div>' +

    '<div class="bn-lev"><h3>Vos trois leviers pour cette nuit</h3>' +
      '<p>Choisis d\'après vos réponses. Aucun ne coûte quoi que ce soit.</p>' + levHtml + '</div>' +

    (sell
      ? '<div class="bn-buy"><h3>La suite, si vous la voulez</h3>' +
        '<p>Notre orthèse thermoformable est conçue pour le ronflement et l\'apnée obstructive légère à modérée : le profil que votre bilan décrit. Elle ne remplace ni un diagnostic, ni un dispositif sur mesure ; elle vous permet d\'essayer sans attendre des mois.</p>' +
        '<a class="bn-cta" href="' + esc(CTA_URL) + '">' + esc(CTA_LABEL) + '</a></div>'
      : '') +

    (soft
      ? '<div class="bn-buy" style="border-color:rgba(239,230,216,.14);"><h3 style="color:var(--lin);">Une exception, à ne prendre que si elle vous concerne</h3>' +
        '<p>Si une apnée <strong>légère à modérée</strong> vous a déjà été diagnostiquée, ou si vous avez essayé la PPC sans la supporter, alors l\'orthèse redevient une piste sérieuse pour vous : et vous n\'avez pas besoin de refaire un examen. Dans tous les autres cas, gardez l\'ordre indiqué plus haut : l\'examen d\'abord.</p>' +
        '<a class="bn-cta-ghost" href="' + esc(CTA_URL) + '">' + esc(CTA_LABEL) + '</a></div>'
      : '') +

    '<div class="bn-actions">' +
      '<button class="bn-cta-ghost" id="bn-copy" type="button">Copier mon bilan</button>' +
      '<button class="bn-cta-ghost" id="bn-print" type="button">Imprimer / PDF</button>' +
      '<button class="bn-cta-ghost" id="bn-again" type="button">Recommencer</button>' +
    '</div>' +
    '<p class="bn-note">Emportez ce résumé à votre prochaine consultation : le score STOP-BANG est un outil que les médecins connaissent, il fait gagner du temps.</p>' +

    '</div>' +
    '<div class="bn-disc"><b>Ce bilan n\'est pas un diagnostic.</b> Il repose sur le questionnaire STOP-BANG, un outil de <i>dépistage</i> du syndrome d\'apnées obstructives du sommeil largement utilisé, et sur les contre-indications reconnues de l\'orthèse d\'avancée mandibulaire. Seul un enregistrement du sommeil réalisé par un professionnel de santé peut établir un diagnostic et une sévérité. En cas de somnolence au volant, de pauses respiratoires constatées ou de symptômes cardiovasculaires, consultez sans attendre. ' +
    'Vos réponses n\'ont été transmises à personne : elles n\'existent que dans la mémoire de cet onglet.</div>' +
    '</div>'
  );

  var emailTemplate = document.getElementById('bn-email-form-template');
  var emailSlot = d.querySelector('#bn-email-form-slot');
  if(emailTemplate && emailSlot){
    emailSlot.appendChild(emailTemplate.firstElementChild.cloneNode(true));
    var clonedForm = emailSlot.querySelector('form');
    if(clonedForm) clonedForm.id = 'bn-newsletter-form';
    var clonedEmail = emailSlot.querySelector('input[type=\"email\"]');
    if(clonedEmail) clonedEmail.id = 'bn-email';
  }

  d.querySelector('#bn-result-content').insertAdjacentHTML('beforeend','');
  d.querySelector('#bn-result-content').hidden = true;

  var emailForm = d.querySelector('#bn-newsletter-form');
  var emailGate = d.querySelector('#bn-email-gate');
  var emailError = d.querySelector('#bn-email-error');
  var resultContent = d.querySelector('#bn-result-content');
  emailForm.addEventListener('submit', function(ev){
    var email = d.querySelector('#bn-email').value.trim();
    if(!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
      ev.preventDefault();
      emailError.classList.add('on');
      return;
    }
    /* Shopify accepte la soumission native : on laisse le formulaire partir.
       Le résultat reste volontairement masqué si Shopify redirige vers /account. */
  });

  /* Si Shopify revient sur la page avec ?customer_posted=true, débloquer le résultat. */
  if(new URLSearchParams(window.location.search).get('customer_posted') === 'true'){
    emailGate.hidden = true;
    resultContent.hidden = false;
  }

  d.querySelector('#bn-again').addEventListener('click', function(){
    S = blank(); store.clear(); i = 0; render();
  });
  d.querySelector('#bn-print').addEventListener('click', function(){ window.print(); });
  d.querySelector('#bn-copy').addEventListener('click', function(){
    var txt = textReport(r, lev, vTitle, bandLbl);
    var done = function(){ TOAST.classList.add('on'); setTimeout(function(){ TOAST.classList.remove('on'); }, 1900); };
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(txt).then(done, function(){ fallbackCopy(txt); done(); });
    } else { fallbackCopy(txt); done(); }
  });
  return d;
}

function fallbackCopy(txt){
  var t = document.createElement('textarea');
  t.value = txt; t.setAttribute('readonly','');
  t.style.position = 'fixed'; t.style.opacity = '0';
  document.body.appendChild(t); t.select();
  try{ document.execCommand('copy'); }catch(e){}
  document.body.removeChild(t);
}

function textReport(r, lev, title, bandLbl){
  var L = [];
  L.push('BILAN NUIT : ' + new Date().toLocaleDateString('fr-FR'));
  L.push('');
  L.push('Score de dépistage STOP-BANG : ' + r.score + '/8 : ' + bandLbl);
  if(r.imc !== null) L.push('IMC : ' + r.imc.toFixed(1));
  L.push('');
  L.push('Critères positifs :');
  var noms = { S:'Ronflement fort', T:'Fatigue diurne', O:'Pauses respiratoires observées',
               P:'Hypertension', B:'IMC supérieur à 35', A:'Âge supérieur à 50 ans',
               N:'Tour de cou supérieur à 40 cm', G:'Sexe masculin' };
  var any = false;
  for(var k in r.items){ if(r.items[k]){ L.push('  - ' + noms[k]); any = true; } }
  if(!any) L.push('  - aucun');
  L.push('');
  L.push('Conclusion : ' + title);
  L.push('');
  L.push('Trois leviers retenus :');
  lev.forEach(function(c, n){ L.push('  ' + (n+1) + '. ' + c.h); });
  L.push('');
  L.push("Outil de dépistage, pas un diagnostic. À confronter à l'avis d'un professionnel de santé.");
  return L.join('\n');
}

SCREENS = [ scrIntro, scrProfil, scrRonfle, scrFatigue, scrArrets, scrHta, scrContre, scrLeviers, scrResult ];
TOTAL = SCREENS.length - 2;
if(i > SCREENS.length - 1) i = SCREENS.length - 1;

render();
})();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bnBoot, { once: true });
  } else {
    bnBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target;
    if (el && el.querySelector && el.querySelector('#bn-app')) bnBoot();
  });
})();
